module.exports = __webpack_public_path__ + "img/gb9115_3.prt.b6b063f4.jpg";